"use strict";
document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#testimonial-carousel', {
		perPage: 1,
        type: 'loop',
        autoplay: true,
        arrows: false,
		breakpoints: {
			640: {
				perPage: 1
			},
		},
  }).mount();
});

